import AR_RESOURCE from "./ar.json";
import EN_RESOURCE from "./en.json";

type Lang = "en" | "ar";

export const translationResources = {
  ar: AR_RESOURCE,
  en: EN_RESOURCE,
} as const;

// Use EN keys as the canonical key set for typing across the app.
export type TranslationKey = keyof typeof EN_RESOURCE;
export type Translation = Record<TranslationKey, string>;

export const getTranslation = (lang: Lang): Translation => {
  const trans = translationResources[lang];
  if (!trans) {
    throw new Error("trans error");
  }
  // Cast to the app-wide Translation shape. Missing keys at runtime will be undefined,
  // so callers should provide fallbacks when indexing.
  return trans as unknown as Translation;
};
